import { useApi } from '@hooks/useApi';
import { ApiError, AcquirerUser, AuthRespSuccess } from '@root/globalTypes';
import { useMutation } from '@tanstack/react-query';
import { isError } from '@utils/apiHelpers';
import { useState } from 'react';

export type AuthData = {
  acquirer: string;
  email: string;
  password: string;
};

export type AuthResp = AuthRespSuccess<AcquirerUser> | ApiError | undefined;

export const useAcquirerLogin = ({
  successHandler,
}: {
  successHandler: (data: AuthRespSuccess<AcquirerUser>) => Promise<void>;
}) => {
  const { query } = useApi();
  const [apiError, setApiError] = useState<string>('');

  const { mutate, isPending } = useMutation({
    mutationFn: (authData: AuthData): Promise<AuthResp> => {
      return query({
        path: 'v1/acquirer/session/login',
        data: authData,
        opt: {
          method: 'POST',
        },
        useAuth: false,
      });
    },
    onSettled: async (data) => {
      if (!data) return;
      if (isError(data)) {
        setApiError(data.message);
      } else {
        await successHandler(data);
      }
    },
    onError: (error) => {
      setApiError(error.message);
    },
  });

  return {
    mutate,
    isPending,
    error: apiError,
  };
};
